import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Form
} from "reactstrap";
import CgnAlert from "../toolbox/CgnAlert";
import CgnLoader from "../toolbox/CgnLoader";
import CgnButtonLink from "../toolbox/CgnButtonLink";
import ContentTop from "../root/ContentTop";
import axios from "axios";
import {
  
  URL,
  localFilePath,
 manuelControlStatus, fotoStyle2, utsStatus
} from "../../redux/actions/constants";
import CgnMessage from "../toolbox/CgnMessage";
import CgnButtonGroup from "../toolbox/CgnButtonGroup";
import CgnReactSelect from "../toolbox/CgnReactSelect";
import pdfIcon from "../../images/pdfIcon.png";
import noImg from "../../images/no-img.png";

class CustomerDocumentProductStatusDetail extends Component {
  state = {
    pageTitle: "Barkod Tamamlanan Detay",
    pageTitleDetail: "Barkod Tamamlanan Detay",
    pageAddLink: "musteri-urun-belge-kayit-ekle",
    pageListLink: "musteri-urun-belge-barkod-tamamlanan-listele",
    breadcrumb: [{ text: "Barkod Tamamlanan Bekleyen", link: "#" }],
    isLoading: false,
    alertErrorMessage: "",
    customerName: "",
    requestedDocumentsName: "",
    customerDocumentProductImageDto: [],
    description: "",
    status: "",
    resultChange: "",
    statusChange: "",
    customerMail: "",
    guid: "",
    createdBy: "",
    total: "",
    createdAt: "",
    isLoadingModal: false,
    updatedAt: "",
    updatedBy: "",
    paymentValue: "",
    isHiddenSuitable: true,
    resultStatusChange: "",
    resultChangeError: "",
    statusChangeError: "",
    resultChangeStatus: "",
    isHiddenUnSuitable: true, 
    isOpenModalPayment: false,
    buttons: [
      {
        type: "submit",
        color: "primary",
        text: CgnMessage.saveButton,
        disabled: this.isLoading,
      },
    ]
  };

  async componentDidMount() {
    let urlSplit = window.location.pathname.split("/");
    if (urlSplit.length === 3) {
      this.setState({
        pageTitle: this.state.pageTitleDetail,
        isLoading: true,
      });
      // 
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      axios
        .get(URL + "/customerDocumentProductRecords/get/" + urlSplit[2], config)
        .then((response) => {
          this.setState({
            guid: response.data.guid,
            customerName: response.data.customerName,
            customerMail: response.data.customerMail,
            requestedDocumentsName: response.data.requestedDocumentsName,
            status: response.data.status,
            createdBy: response.data.createdBy,
            createdAt: response.data.createdAt,
            updatedBy: response.data.updatedBy,
            updatedAt: response.data.updatedAt,
            customerDocumentProductImageDto: response.data.customerDocumentProductImageDto,
            resultChange: response.data.resultChange,
            statusChange: response.data.statusChange,
            isLoading: false,
          });
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
    }
  }


  fileClick = (image) => {
    var myData = image;
    let replaceLink = myData.replace(localFilePath + "/Files/", "");
    if (replaceLink) {
      window.open("/Files/" + myData, "_blank");
      this.setState({
        isLoading: false,
      });
    }
  };

  handleStatusSelectChange(status) {
    if (status) {
      this.setState({
        resultStatusChange: status.value,
        resultChangeError: "",
        alertErrorMessage: "",
      });
    } else {
      this.setState({
        resultStatusChange: "",
        resultChangeError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
  }

  handleSave = async (event) => {
    event.preventDefault();
    this.setState({
      isLoading: true,
    });
    if(this.state.resultStatusChange === null || this.state.resultStatusChange === ""){
      this.setState({
        resultChangeError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
        isLoading: false,
      });
    }
    else if(this.state.resultStatusChange !== null || this.state.resultStatusChange !== ""){
      // 
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      var URLParam = "/customerDocumentProductRecords/updateproductstatus";
      var myObj = {
        guid: this.state.guid,
        statusChange: this.state.resultStatusChange,
        customerMail: this.state.customerMail,
        customerName: this.state.customerName,
      };
       await axios
        .post(URL + URLParam, myObj, config)
        .then((response) => {
          setTimeout(() => {
            window.location.href = "/musteri-urun-belge-barkod-tamamlanan-listele";
          }, 1500);
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
    }
    else {
      this.setState({
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
  }


  handleChange = async (event) => {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  };

  render() {
    const mainRow = {
      backgroundColor: "#1d4b8c",
      color: "#fff",
    };
    var self1 = this;
    return (
      <>
        <ContentTop
          breadcrumb={this.state.breadcrumb}
          title={this.state.pageTitle}
          listLink={"/" + this.state.pageListLink}
        />
        <Row>
          <Col>
            <Card body className="table-responsive">
              <CgnLoader visibled={this.state.isLoading} />
              
              <Table className="table table-responsive table-hover">
                <tbody>
                  <tr>
                    <th>Müşteri</th>
                    <td colSpan="4">
                      {this.state.customerName ? this.state.customerName : "-"}
                    </td>
                  </tr>

                  <tr>
                    <th>İstenen Ürün Belgeler</th>
                    <td colSpan="4">
                      {this.state.requestedDocumentsName
                        ? this.state.requestedDocumentsName
                        : "-"}
                    </td>
                  </tr>

                  <tr>
                    <th>Kaydeden Kullanıcı</th>
                    <td>{this.state.createdBy ? this.state.createdBy : "-"}</td>
                    <th>Kaydedilme Tarihi</th>
                    <td>{this.state.createdAt ? this.state.createdAt : "-"}</td>
                  </tr>
                  <tr>
                    <th>Son Güncelleyen Kullanıcı</th>
                    <td>{this.state.updatedBy ? this.state.updatedBy : "-"}</td>
                    <th>Son Güncellenme Tarihi</th>
                    <td>{this.state.updatedAt ? this.state.updatedAt : "-"}</td>
                  </tr>

                  <tr>
                    <th>Durumu</th>
                    <td colSpan="4">
                      {this.state.statusChange === 4 ? "Onaylandı" : this.state.statusChange === 5 ? "Red" : this.state.statusChange === 6 ? "Kayıtlı" : 
                      this.state.statusChange === 7 ? "Revizyon" : this.state.statusChange === 8 ? "Teslim Edildi" : "-"}
                    </td>
                  </tr>
                </tbody>
              </Table>

              {this.state.customerDocumentProductImageDto &&
                this.state.customerDocumentProductImageDto.length > 0 && (
                  <Table className="table table-responsive table-hover table-product2 mb-3">
                    <tr style={mainRow}>
                      <th>Barkod Görüntüleri</th>
                    </tr>
                    <Row>
                      {this.state.customerDocumentProductImageDto.map(function (item) {
                        return (
                          <>
                            <div className="pl-2">
                              <Button
                                onClick={() => self1.fileClick(item.image)}
                                className="modalButtonDetail"
                              >
                                <img
                                  src={pdfIcon}
                                  style={fotoStyle2}
                                  alt={item.imageName}
                                />
                              </Button>
                              <p style={{ maxWidth: "150px" }}>
                                {item.imageName}
                              </p>
                            </div>
                          </>
                        );
                      })}
                    </Row>
                  </Table>
                )}
              
            </Card>
            <Table>
            <Card body className="table-responsive pb-5">   
            <CgnLoader visibled={this.state.isLoading} />          
            <Form onSubmit={this.handleSave}>              
            <Col lg="12" className="pl-0">
                    <CgnReactSelect
                      name="resultStatusChange"
                      placeholder="Durum seçiniz..."
                      label="Durumu"
                      isMulti={false}
                      selectValue={this.state.resultStatusChange}
                      options={utsStatus}
                      onChange={(status) =>
                        this.handleStatusSelectChange(status)
                      }
                      error={this.state.resultChangeError}
                    />
                  </Col>           
                    <CgnButtonGroup items={this.state.buttons} />
                 </Form>
                {this.state.alertErrorMessage && (
                <CgnAlert
                  color="danger"
                  title="Uyarı"
                  text={this.state.alertErrorMessage}
                />
              )}
            </Card>
            </Table>


            <CgnButtonLink
              color="secondary"
              to={"/" + this.state.pageListLink}
              text="Geri"
              className="btn-back"
            />           
          </Col>
        </Row>
      </>
    );
  }
}

export default CustomerDocumentProductStatusDetail;
